import { c as _c } from "react/compiler-runtime";
import { SVGProps } from "react";
export const MassifLogo = props => {
  const $ = _c(6);
  const {
    className
  } = props;
  const t0 = `${className}`;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>MASSIF Web Studio</title>;
    t2 = <rect fill="white" x="0" y="4" width="40" height="28.6" />;
    t3 = <path className="fill-accent" d="M0 0v33.54h43.6V0Zm5.92 24.89 5.54-9.49 3.72 9.49Zm11.27 0L10.82 8.65h9.24l6.37 16.24Zm11.24 0L22.06 8.65h9.24l6.37 16.24Z" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <g fill="currentColor"><path d="M70.46 5.72h2v22.06h-5.74V18L62 22.88h-.63L56.76 18v9.8H51V5.72h2.08l8.61 9.55ZM109.69 20.8c0-1.54-1.82-1.79-4-1.92-4.78-.35-7.92-2-8-6.76-.19-9.49 16.9-9.49 16.78 0h-5.34c0-2.92-5.91-2.67-6.1-.06-.13 1.66 1.51 2 3.49 2.23 4.37.47 8.64 1 8.64 6.54 0 9.24-17.91 9.49-17.79-.19h5.44c0 2.8 6.88 2.73 6.88.16ZM130.13 20.8c0-1.54-1.82-1.79-4-1.92-4.77-.35-7.92-2-8-6.76-.19-9.49 16.91-9.49 16.78 0h-5.34c0-2.92-5.91-2.67-6.1-.06-.12 1.66 1.51 2 3.49 2.23 4.37.47 8.64 1 8.64 6.54 0 9.24-17.91 9.49-17.79-.19h5.43c.01 2.8 6.89 2.73 6.89.16ZM144.73 22.89v4.93h-5.56V5.83h5.56V22.89ZM154.67 20.69v7.13h-5.72v-22h13.7v5h-8v4.81h7.07v5ZM86.89 5.55h-2.42L74.57 27v.82h5.5l1.29-2.77H90l1.29 2.77h5.5V27ZM83.4 20l2.26-5.06L88 20Z" /></g>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t0) {
    t5 = <><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 162.65 33.54" className={t0}>{t1}{t2}{t3}{t4}</svg></>;
    $[4] = t0;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export const RedaxoLogo = props => {
  const $ = _c(4);
  const {
    className
  } = props;
  const t0 = `${className || ""}`;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>REDAXO CMS</title>;
    t2 = <path fill="currentColor" d="M40,39.99H0V0h40v39.99ZM27.62,24.16c.12-.24.29-.29.43-.38,1.04-.63,1.95-1.39,2.7-2.36.99-1.27,1.47-2.74,1.74-4.3.55-3.14-.49-5.72-2.87-7.76-1.76-1.51-3.88-2.15-6.19-2.15-4.3,0-8.61,0-12.91,0-.18,0-.38-.03-.61.14-.85,8.4-1.7,16.85-2.55,25.36h6.47c.37-2.55.45-5.1.84-7.58.2-.11.37-.1.52-.1,1.74,0,3.48.01,5.22-.01.41,0,.59.17.74.51.99,2.25,2,4.5,2.98,6.76.15.35.33.48.7.48,2-.02,4,0,6,0,.15,0,.32.05.51-.16-1.24-2.8-2.49-5.64-3.73-8.44ZM15.89,18.58c2.27,0,4.55,0,6.82,0,.6,0,1.18-.08,1.75-.29,1.19-.43,1.82-1.44,1.63-2.64-.17-1.09-1.11-1.89-2.31-1.91-2.5-.04-5.01-.04-7.52-.06-.34,0-.49.12-.52.47-.12,1.28-.27,2.56-.4,3.84-.02.16-.06.31.01.47.15.16.35.12.53.12Z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t0) {
    t3 = <><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 39.99" width="1em" height="1em" className={t0}>{t1}{t2}</svg></>;
    $[2] = t0;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export const GsapLogo = props => {
  const $ = _c(7);
  const {
    className
  } = props;
  const t0 = `${className || ""}`;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>GSAP</title>;
    t2 = <path fill="currentColor" d="M23.81 14.012v.013l-1.075 4.666c-.058.264-.322.457-.626.457H20.81a.218.218 0 0 0-.208.156c-1.198 4.064-2.82 6.857-4.962 8.534-1.822 1.428-4.068 2.094-7.069 2.094-2.696 0-4.514-.867-6.056-2.579-2.038-2.262-2.88-5.966-2.37-10.428C1.065 8.548 5.41.095 13.776.095c2.545-.022 4.543.763 5.933 2.33 1.47 1.658 2.216 4.154 2.22 7.422a.55.55 0 0 1-.549.536h-6.13a.42.42 0 0 1-.407-.41c-.05-2.26-.72-3.36-2.052-3.36-2.35 0-3.736 3.19-4.471 4.958-1.027 2.47-1.55 5.153-1.447 7.825.049 1.244.249 2.993 1.43 3.718 1.047.642 2.541.216 3.446-.495.904-.712 1.632-1.943 1.938-3.066.043-.156.046-.277.005-.331-.043-.056-.162-.069-.253-.069h-1.574a.572.572 0 0 1-.438-.202.42.42 0 0 1-.087-.362l1.076-4.674c.053-.239.27-.42.537-.452v-.012h10.33c.024 0 .049 0 .072.005.268.035.457.284.452.556h.002Z" />;
    t3 = <path fill="currentColor" d="M41.595 8.65a.548.548 0 0 1-.548.53h-5.646c-.37 0-.679-.3-.679-.665 0-1.647-.57-2.449-1.736-2.449s-1.918.716-1.94 1.967c-.025 1.395.764 2.663 3.01 4.841 2.957 2.774 4.142 5.231 4.085 8.479C38.048 26.605 34.477 30 29.043 30c-2.775 0-4.895-.742-6.305-2.206-1.431-1.487-2.087-3.669-1.95-6.485a.548.548 0 0 1 .549-.53h5.84a.55.55 0 0 1 .422.208.48.48 0 0 1 .106.384c-.065 1.016.112 1.775.512 2.195.256.272.613.41 1.058.41 1.079 0 1.711-.762 1.735-2.09.02-1.148-.343-2.154-2.321-4.189-2.555-2.496-4.846-5.075-4.775-9.13.042-2.352.976-4.503 2.631-6.057C28.295.868 30.688 0 33.466 0c2.783.02 4.892.814 6.269 2.36 1.304 1.465 1.931 3.581 1.862 6.29h-.002Z" />;
    t4 = <path fill="currentColor" d="m59.095 29.012.037-27.933a.525.525 0 0 0-.529-.533h-8.738c-.294 0-.423.253-.507.42L36.706 28.841v.005l-.005.007c-.14.343.126.71.497.71h6.108c.33 0 .549-.1.656-.308l1.213-2.915c.149-.389.177-.425.601-.425h5.836c.406 0 .414.008.408.405l-.131 2.71a.525.525 0 0 0 .528.533h6.171a.523.523 0 0 0 .403-.182.458.458 0 0 0 .104-.369Zm-10.81-9.326a1.67 1.67 0 0 1-.138-.005.147.147 0 0 1-.13-.184c.012-.04.029-.095.054-.162l4.376-10.828a2.99 2.99 0 0 1 .136-.313c.071-.146.157-.156.184-.048.023.09-.502 11.118-.502 11.118-.041.413-.06.43-.467.464l-3.509-.04h-.008l.003-.002Z" />;
    t5 = <path fill="currentColor" d="M71.543.546h-4.639c-.245 0-.52.13-.584.422l-6.456 28.03a.423.423 0 0 0 .088.363.573.573 0 0 0 .437.202h5.798c.312 0 .525-.153.583-.418l.704-3.177c.05-.248-.036-.44-.258-.556a52.313 52.313 0 0 1-.312-.162l-1.005-.523-1-.522-.387-.201a.186.186 0 0 1-.103-.17.199.199 0 0 1 .2-.194l3.177.014c.95.005 1.901-.062 2.836-.234 6.58-1.215 10.95-6.485 11.076-13.656.108-6.12-3.308-9.221-10.15-9.221l-.005.003Zm-1.579 16.68h-.124c-.279 0-.328-.03-.336-.04-.005-.007 1.832-8.073 1.833-8.084.047-.233.045-.367-.099-.446-.184-.102-2.866-1.516-2.866-1.516a.189.189 0 0 1-.101-.172.197.197 0 0 1 .197-.192h4.241c1.32.04 2.056 1.221 2.021 3.238-.061 3.491-1.721 7.09-4.766 7.213Z" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t0) {
    t6 = <><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 82 30" width="1em" height="1em" className={t0}>{t1}{t2}{t3}{t4}{t5}</svg></>;
    $[5] = t0;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};